import React, { ReactNode } from 'react';
import { skipToken } from '@reduxjs/toolkit/query';
import { getBlackourLocationForDate } from '@pages/Schedule/utils/getBlackoutsLocationForDate';
import { useLanguageContext } from '@hooks/useLanguageContext';
import { useFetchAllPhysiciansQuery } from '@api/physicians/physiciansAPI';
import { useScheduleContext } from '@pages/Schedule/context/useScheduleContext';
import { useFetchLocationBlackoutsQuery } from '@api/blackout/blackoutAPI';
import { getWeekDates } from '@pages/Schedule/utils/getWeekDates';

export const WeekHeader = () => {
  const { dictionary } = useLanguageContext();

  const { selectedPhysician, selectedLocationId, selectedDate } = useScheduleContext();

  const { data: physicians } = useFetchAllPhysiciansQuery();

  const physiciansName = physicians?.data?.results
    .filter((physician) => physician?.schedule?.locationId === selectedLocationId)
    .map((physician) =>
      selectedPhysician?.length
        ? physician.id === selectedPhysician && physician.name
        : physician.name,
    );

  const { data: locationsBlackout } = useFetchLocationBlackoutsQuery(
    !selectedLocationId ? skipToken : selectedLocationId,
  );

  const selectedWeekDates = getWeekDates(selectedDate);

  const weekBlackoutLocations = selectedWeekDates.map((date) =>
    getBlackourLocationForDate(date, locationsBlackout?.data),
  );

  const isCurrentBlackoutLocations = weekBlackoutLocations.some((blackoutLocationsSlots) =>
    blackoutLocationsSlots?.some((slot) => slot.locationId === selectedLocationId),
  );

  const hasPhysicians = Array.isArray(physiciansName) && physiciansName.length > 0;

  const includeBlackout = hasPhysicians && isCurrentBlackoutLocations;

  const tableSettings = [
    dictionary.schedule.table.dayOfWeek,
    ...(includeBlackout ? ['Blackout location'] : []),
    ...(hasPhysicians ? physiciansName : []),
  ];

  const tableHeader = tableSettings
    ?.reduce<ReactNode[] | any>(
      (acc, item, currentIndex) => [
        ...acc,
        <div className="schedule-cell table-cell is-heading" key={`schedule-cell-${currentIndex}`}>
          {item}
        </div>,
      ],
      [],
    )
    .map(
      (children: { props: { children: string } }) => children?.props.children.length && children,
    );

  return (
    <div className="schedule-header table-header">
      <div className="schedule-row table-row">{tableHeader}</div>
    </div>
  );
};
